export async function exportToCsv(filename,rows,separator = ';') {
    const processRow = function (row) {
        let finalVal = '';

        for (let j = 0; j < row.length; j++) {
            let innerValue = row[j] === null ? '' : row[j].toString();

            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            }

            let result = innerValue.replace(/"/g, '""');

            if (result.search(/("|,|\n)/g) >= 0)
            {result = `"${  result  }"`;}

            if (j > 0)
            {finalVal += separator;}

            finalVal += result;
        }

        return `${finalVal  }\n`;
    };

    let csvFile = '';

    for (let i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    const blob = new Blob(['\ufeff', csvFile], { type: 'text/csv;charset=utf-8;' });

    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        const link = document.createElement('a');

        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);

            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}